import type { RegisteredComponent } from "@builder.io/sdk-react";

import { PlpBottomBanner } from "./plp-bottom-banner";

export const PlpBottomBannerDefinition: RegisteredComponent = {
  component: PlpBottomBanner,
  name: "PlpBottomBanner",
  canHaveChildren: true,
  noWrap: true,
};
